"use client";

import "../lib/css/ui.scss";
import { useEffect, useState } from "react";
import LinkElement from "./LinkElement";
import { MessageIcon } from "./icons";
import PopupV2 from "./PopupV2";
import { useAppDispatch, useAppSelector } from "@/redux/hook";
import { setProductComparesState } from "@/redux/features/ShopSlice";
import ProductCompare from "~components/product/ProductCompare";
import useTranslationApi from "@/lib/hooks/useTranslationApi";
import ContactIcon from "./icons/ContactIcon";
import ScrollButton from "~components/floatButton/ScrollButton";
import { usePathname, useRouter } from "next/navigation";
import Local from "@/common/constants/local";

// import LiveIcon from "./icons/LiveIcon";
// import FloatButton from "~components/floatButton/FloatButton";
// import Image from "@/components/ui/Image";
// import ChatMessageBox from "~components/chat/ChatMessageBox";
// import SocialIcon from "./icons/SocialIcon";

export default function FloatButtonPage() {
	const { t } = useTranslationApi(["compare", "chat_now"]);
	const pathname = usePathname();
	const router = useRouter();
	const dispatch = useAppDispatch();
	const productCompares = useAppSelector(
		(state) => state.ShopReducer.productCompares
	);

	const routerDisableChat = ["checkouts", "pos"];

	useEffect(() => {
		const localItem = localStorage.getItem(Local.storage.productCompare);
		if (localItem) {
			let parseCompare = JSON.parse(localItem);
			if (parseCompare && parseCompare.length > 0) {
				dispatch(setProductComparesState(parseCompare));
			}
		}
	}, []);

	const [open, setOpen] = useState(false);

	return (
		<div className="floatbtn_wrapper  z-50">
			{/* <div className={`float_box ${!open ? "active_close" : ""}`}>
				<div
					className="float_box_button"
					onClick={() => {
						setOpen((prev) => !prev);
					}}>
					<SocialIcon></SocialIcon>
				</div>
				<div
					className="float_box_item"
					style={{ "--i": "1" } as React.CSSProperties}>
					<FloatButton
						id="nperp_live"
						icon={
							<LiveIcon className="w-[40px] h-[40px] md:w-[60px] md:h-[60px]" />
						}
						type={Website.FLOAT_BUTTON.LIVE}
						key_setting={SettingApi.QUICKCONTACT.k_title_live}
					/>
				</div>
				<div
					className="float_box_item"
					style={{ "--i": "2" } as React.CSSProperties}>
					<FloatButton
						id="nperp_contact"
						icon={
							<ContactIcon className="w-[40px] h-[40px] md:w-[60px] md:h-[60px]" />
						}
						type={Website.FLOAT_BUTTON.CONTACT}
						key_setting={SettingApi.QUICKCONTACT.k_title_contact}
					/>
				</div>
				<div
					className="float_box_item"
					style={{ "--i": "3" } as React.CSSProperties}>
					<ChatMessageBox></ChatMessageBox>
				</div>
			</div> */}
			{/* <div className="compare z-header left-[25px] md:bottom-[85px] bottom-[111px] fixed cursor-pointer md:rouded-none rounded-[30px] overflow-hidden">
				<MessageAbout className="md:w-[60px] md:h-[60px] w-[30px] h-[30px]" />
			</div> */}
			{!routerDisableChat.some((i) => pathname.includes(i)) && (
				<div
					className={`chatbox z-[500] left-[16px] lg:bottom-[25px] ${
						pathname.includes("products") ? "bottom-[106px]" : "bottom-[65px]"
					} fixed cursor-pointer md:rouded-none rounded-[30px] overflow-hidden`}>
					<LinkElement
						passHref={true}
						target="_blank"
						href="https://m.me/Namperfumee"
						aria-label="chat with us">
						<ContactIcon className="lg:block hidden"></ContactIcon>
						<div className="lg:hidden w-full text-red-500 text-sm flex gap-2 items-center justify-center  h-[30px] rounded-[30px] border border-red-500 px-3 bg-white ">
							<MessageIcon className="text-red-500 w-4 h-4" />
							{t("chat_now")}
						</div>
					</LinkElement>
				</div>
			)}

			<ScrollButton />
			{/* {!pathname.includes("checkouts") && (
				<div
					onClick={() => {
						// setOpen(true);
						router.push(
							`/pages/so-sanh-san-pham/${
								productCompares.length > 0
									? productCompares.map((item) => item.product.handle).join("/")
									: ""
							}`
						);
					}}
					className="fixed text-center border border-blue-500  left-[25px] md:bottom-[100px] w-auto bottom-[111px]  z-[500] shadow-default rounded-[30px] bg-white  px-3 h-[30px] text-blue-500 cursor-pointer place-content-center">
					<p className="text-base">
						{t("compare")} ({productCompares.length})
					</p>
				</div>
			)} */}

			<PopupV2
				isDrawerMobile
				open={open}
				onOpenChange={() => setOpen(false)}
				classNameContent="md:max-w-fit w-full">
				<ProductCompare
					onClose={() => {
						setOpen(false);
					}}></ProductCompare>
			</PopupV2>
		</div>
	);
}
